import { useState, useEffect } from "react";
import { RoomService } from "../../services/RoomService";
import { Equipment } from "../../types";

interface UseEquipmentResult {
  equipment: Equipment[];
  loading: boolean;
}

export function useEquipment(): UseEquipmentResult {
  const [equipment, setEquipment] = useState<Equipment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEquipment = async (): Promise<void> => {
      try {
        const data = await RoomService.getEquipmentOptions();
        setEquipment(data);
      } catch {
        setEquipment([]);
      } finally {
        setLoading(false);
      }
    };

    void loadEquipment();
  }, []);

  return { equipment, loading };
}
